<template>
<div class="card-page" v-bind="getPT('root')" data-pc-section="root">
    <div v-if="title || $slots.title" class="grid grid-nogutter mb-5">
        <div class="col">
            <h3 v-if="title">{{ title }}</h3>
            <slot v-else name="title"></slot>
            <p v-if="description">{{ description }}</p>
        </div>
    </div>
    <div v-if="$slots.header" class="grid grid-nogutter">
        <div class="col-12">
            <slot name="header"></slot>
        </div>
    </div>
    <div class="grid grid-nogutter">
        <div v-if="infoMessage" class="col-12">
            <AdaptersMessage :message="infoMessage" severity="info" />
        </div>
        <div v-if="errorMessage" class="col-12">
            <AdaptersMessage :message="errorMessage" />
        </div>
    </div>
    <div class="grid grid-nogutter relative">
        <div v-if="loading" class="col-12">
            <AdaptersLoader :loading="loading" />
        </div>
        <div class="col flex flex-column">
            <slot></slot>
            <template v-if="$slots.result">
                <Divider />
                <slot name="result"></slot>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import AdaptersLoader from "../component/adapters/Loader.vue";
import AdaptersMessage from "../component/adapters/Message.vue";
import Divider from "primevue/divider";
import PassThrough from "../mixins/PassThrough";

/**
 * Доступные Pass Through:
 *      root, -- контейнер
 */
export default {
    name: "TemplatesPage",
    slots: ['title', 'header', 'default', 'result'],
    mixins: [PassThrough],
    props: {
        title: {
            type: String,
            required: false,
            default: null,
        },
        description: {
            type: String,
            required: false,
            default: null,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorMessage: {
            type: String,
            required: false,
            default: null,
        },
        infoMessage: {
            type: String,
            required: false,
            default: null,
        },
    },
    components: {
        AdaptersLoader,
        AdaptersMessage,
        Divider,
    }
}
</script>

<style scoped>
.card-page {
    position: relative;
    margin: 0 auto;
}
.p-divider {
    margin: 2rem 0;
}
</style>
